export const passwordMinLength = 6;
